import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';

/**
 * The marketplace clears the Apollo store on login and logout (use-user-button,
 * use-user-controller) with `clearStore`, which cancels in-flight queries and —
 * unlike `resetStore` — never retries them, leaving the concierge's bridge
 * data in a perpetual loading state.
 *
 * This restores the missing half: after the store is cleared, re-run the bridge's
 * active queries. We scope to the bridge's own operations rather than calling
 * reFetchObservableQueries() (which refetches all app-wide queries and can cause
 * browser hangs on query-heavy pages). Apollo silently ignores names that have
 * no active subscriber, so the list is safe to call on both login and logout.
 *
 * Add operation names here when adding a new Apollo query to the bridge chain.
 */
const BRIDGE_QUERIES = ['GetDutchiePosLoyaltyConfig', 'GetRewardsV2'] as const;

export function useRefetchOnStoreClear(): void {
  const apolloClient = useApolloClient();
  useEffect(() => apolloClient.onClearStore(() => apolloClient.refetchQueries({ include: [...BRIDGE_QUERIES] })), [
    apolloClient,
  ]);
}
